<desy-card
  classes="w-1/3"
  [containerClasses]="'p-base border-2 mb-4 w-[1200px] lg:min-w-0 custom-card-width border-neutral-light '">
  <div class="p-4 mb-4 text-sm">
    <div class="flex justify-between items-start w-[1150px] pr-4">
      <div>
        <p class="text-black font-semibold">
          {{ title }}
          <span class="ml-[16px]"></span>
          <span class="text-neutral-dark font-normal text-nowrap">Adhesión {{ id }}</span>
        </p>
        <div class="flex items-center mt-1 space-x-2">
          <div
            class="w-3 h-3 color rounded-sm"
            [ngClass]="color"></div>
          <span class="font-semibold font-[16px]">{{ stateText }}</span>
          <span class="text-black font-normal font-[16px] ml-[16px]">Creada el {{ creationDate | spanishDate }}</span>
        </div>
      </div>
      <div class="flex items-center gap-2">
        @if (buttonAction) {
          <div class="text-sm text-primary-600 cursor-pointer flex items-center space-x-1">
            <desy-button
              (clickEvent)="buttonAction()"
              classes="c-button c-button--transparent c-button--sm ng-star-inserted underline font-semibold">
              {{ buttonText }}
            </desy-button>
          </div>
        } @else {
          <div
            aria-hidden="true"
            style="width: 9rem"></div>
        }
        @if (approvedActions && approvedActions.options) {
          <div class="text-sm text-primary-600 cursor-pointer flex items-center space-x-1">
            <desy-header-dropdown style="margin-left: auto">
              {{ approvedActions.label }}
              <desy-nav>
                @for (b of approvedActions.options; track b.label) {
                  <desy-nav-item (clickEvent)="b.action(b)">{{ b.label }}</desy-nav-item>
                }
              </desy-nav>
            </desy-header-dropdown>
          </div>
        }
        <button
          class="border border-primary-base text-primary-base text-[14px] font-semibold py-1 rounded hover:bg-primary-base hover:text-white transition"
          [queryParams]="{ list: query }"
          style="min-width: 9rem"
          [routerLink]="detailUrl">
          Consultar adhesión
        </button>
      </div>
    </div>

    <div
      class="grid grid-cols-1 md:grid-cols-3 mt-4 border-t border-neutral-300 pt-4 w-[1130px] gap-6 text-neutral-dark">
      <div>
        <p class="text-[15px] font-normal text-neutral-dark">Servicio</p>
        <p class="text-[16px] text-black">{{ service }}</p>
      </div>
      <div class="flex flex-col items-center">
        <p class="text-[15px] font-normal text-neutral-dark">RPTs adheridos</p>
        <div class="flex items-center gap-1">
          <desy-tooltip id="tooltip1">
            <desy-content>
              <span class="text-[16px] text-black">{{ rpts.length }}</span>
            </desy-content>
            <desy-icon type="info"></desy-icon>
            <desy-tooltip-content>
              <ul
                class="list-none"
                *ngFor="let rpt of rpts">
                <li>{{ rpt.firstName }} {{ rpt.lastName }} - {{ rpt.position }}</li>
              </ul>
            </desy-tooltip-content>
          </desy-tooltip>
        </div>
      </div>
      <div>
        <p class="text-[15px] font-normal text-neutral-dark">Tiempo de vigencia</p>
        <p class="text-[16px] text-black">
          {{ isOlderThan50Years(validatedTime) ? (validatedTime | spanishDate) : 'Indefinida' }}
        </p>
      </div>
    </div>
  </div>
</desy-card>
